import { Dropdown, Input, Table } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../assets/svg/svg27.svg";
import DeleteModal from "../../components/DeleteModal";
import svg38 from "../../assets/svg/svg38.svg";
import MaterialIcon from "material-icons-react";
import InsideHeader from "../../components/InsideHeader";
import NoDataTable from "../../components/NoDataTable";
import { deleteAttendance } from "../../features/staff-setting/staffSettingSlice";
import { dateForHumans } from "../../utils";
import { setAttendanceHeaderObj } from "../../features/folder/folderSlice";


import { MapContainer, TileLayer, GeoJSON, LayersControl, Polyline, Tooltip, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet-polylinedecorator';
import { fetchAttendanceLocations, getUserActivities } from "../../features/dropdown/dropdownSlice";

export default function AttendanceMap() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const icons = {
    CHECK_IN: L.icon({
      iconUrl: "/check-in-icon.png",
      iconSize: [36, 36],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    }),
    CHECK_OUT: L.icon({
      iconUrl: "/check-out-icon.png",
      iconSize: [36, 36],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    }),
    HOME: L.icon({
      iconUrl: "/home.png",
      iconSize: [36, 36],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    }),
    LOCATION: L.icon({
      iconUrl: "/location.png",
      iconSize: [36, 36],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    }),
    TICKET: L.icon({
      iconUrl: "/to-do-list.png",
      iconSize: [36, 36],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    }),
    PUSH_PIN: L.icon({
      iconUrl: "/push-pin.png",
      iconSize: [36, 36],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    }),
    DEFAULT: L.icon({
      iconUrl: "/default-icon.png",
      iconSize: [36, 36],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    }),

  };
  const { BaseLayer } = LayersControl;

  function formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const [geoData, setGeoData] = useState(null); // Full GeoJSON data
  const [geoDataCustomerSurvey, setGeoDataCustomerSurvey] = useState(null);

  const [GeoDataMetereadingInspection, setGeoDataMetereadingInspection] = useState(null);
  const [FilteredMetereadingInspection, setFilteredMetereadingInspection] = useState(null);
  const [GeoDataMeterReadingByUserId, setGeoDataMeterReadingByUserId] = useState(null);
  const [FilteredMeterReadingByUserId, setFilteredMeterReadingByUserId] = useState(null);
  const [GeoDataMeterInstallation, setGeoDataMeterInstallation] = useState(null);
  const [FilteredMeterInstallation, setFilteredMeterInstallation] = useState(null);
  const [GeoDataMyTickets, setGeoDataMyTickets] = useState(null);
  const [FilteredMyTickets, setFilteredMyTickets] = useState(null);

  const [filteredData, setFilteredData] = useState(null);

  const [filteredCustomerSurvey, setFilteredCustomerSurvey] = useState(null);

  // Filtered GeoJSON data
  const [selectedType, setSelectedType] = useState("ALL"); // Selected attdType filter
  const [selectedName, setSelectedName] = useState("ALL"); // Selected ppFullname filter
  const [uniqueNames, setUniqueNames] = useState([]); // List of unique names for filtering
  const [selectedDate, setSelectedDate] = useState(formatDateToYYYYMMDD(new Date()));
  const [selectedRow, setSelectedRow] = useState(null);
  const { locationDetails } = useSelector((state) => state.dropdown);
  const [selectedUser, setSelectedUser] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState([]);


  const mapRef = useRef(); // Create reference for the map instance

  //const baseUrl = "http://localhost:8080/NDOVUHR_BACKEND/gis/getAttendanceLocations.action?usrId=1";

  const convertToGeoJSON = (apiData) => {
    const features = apiData.map((item) => ({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [item.attdLong, item.attdLat],
      },
      properties: {
        attdType: item.attdType,
        clockedTime: item.clockedTime,
        attdClockedDate: new Date(item.attdClockedDate).toLocaleString(),
        ppFullname: item.ppFullname,
        ppFile: item.ppFile,
        ppId: item.ppId,
      },
    }));

    return {
      type: "FeatureCollection",
      features,
    };
  };

  const convertToGeoJSONCustomerSurvey = (apiData) => {
    const features = apiData.map((item) => ({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [item.customersurv_long, item.customersurv_lat],
      },
      properties: {
        customersurv_created_date: new Date(item.customersurv_created_date).toLocaleString(),
        customersurv_name: item.customersurv_name,
        customersurv_status: item.customersurv_status,
        customersurv_enq_reason_1: item.customersurv_enq_reason_1,
      },
    }));

    return {
      type: "FeatureCollection",
      features,
    };
  };

  const convertToGeoJSONMeterInstallation = (apiData) => {
    const features = apiData.map((item) => ({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [item.mui_long, item.mui_lat],
      },
      properties: {
        mui_requested_date: new Date(item.mui_requested_date).toLocaleString(),
        mui_request_type: item.mui_request_type,
        mui_ground_status: item.mui_ground_status,
      },
    }));

    return {
      type: "FeatureCollection",
      features,
    };
  };

  const convertToGeoJSONMeterReadingByUserId = (apiData) => {
    const features = apiData.map((item) => ({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [item.mtr_long, item.mtr_lat],
      },
      properties: {
        mtr_date: new Date(item.mtr_date).toLocaleString(),
        mtr_status: item.mtr_status,
        c_account_name: item.c_account_name,
        mtr_reading_type: item.mtr_reading_type
      },
    }));

    return {
      type: "FeatureCollection",
      features,
    };
  };

  const convertToGeoJSONMetereadingInspection = (apiData) => {
    const features = apiData.map((item) => ({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [item.mtri_long, item.mtri_lat],
      },
      properties: {
        mtri_synced_date: new Date(item.mtri_synced_date).toLocaleString(),
        c_account_name: item.c_account_name,
        c_acc_number: item.c_acc_number,
        mtri_remarks: item.mtri_remarks
      },
    }));

    return {
      type: "FeatureCollection",
      features,
    };
  };


  const convertToGeoJSONMyTickets = (apiData) => {
    const features = apiData.map((item) => ({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [item.tk_longi, item.tk_lati],
      },
      properties: {
        tk_message: item.tk_message,
        tk_status: item.tk_status
      },
    }));

    return {
      type: "FeatureCollection",
      features,
    };
  };




  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate); // Update state, triggering the useEffect to refetch data
  };

  const handlePersonChanged = (event, ppId) => {
    //const newUser = event.target.value;
    setSelectedUser(ppId); // Update state, triggering the useEffect to refetch data

    getUserActivitiesData(selectedDate, ppId, event);
  };

  // console.log("locationDetails", locationDetails)
  async function fetchData(date) {
    console.log("entering date", date)
    const res = await dispatch(fetchAttendanceLocations({
      date: date
    }))
    console.log("res", res)
    if (res?.payload?.success) {
      const geoJSON = convertToGeoJSON(res?.payload?.data?.result);
      setGeoData(geoJSON);
      setFilteredData(geoJSON); // Initialize filtered data with full dataset
      // Extract unique names for filtering
      const names = Array.from(new Set(res?.payload?.data?.result?.map((item) => item?.ppFullname)));
      setUniqueNames(names);
    } else {
      toast.error(res?.payload?.messages?.message ?? "Error fetching geolocation data")
    }

  }

  async function getUserActivitiesData(date, ppId, ppFullname) {
    const res = await dispatch(getUserActivities({
      date: date,
      usrId: ppId,
      ppFullName: ppFullname
    }))
    console.log("res", res)
    if (res?.payload?.success) {
      const CustomerSurveygeoJSON = convertToGeoJSONCustomerSurvey(res?.payload?.data?.CustomerSurvey);
      setGeoDataCustomerSurvey(CustomerSurveygeoJSON);
      setFilteredCustomerSurvey(CustomerSurveygeoJSON);
      // Extract unique names for filtering

      const MeterInstallationgeoJSON = convertToGeoJSONMeterInstallation(res?.payload?.data?.MeterInstallation);


      const MeterReadingByUserIdgeoJSON = convertToGeoJSONMeterReadingByUserId(res?.payload?.data?.MeterReadingByUserId);


      const MetereadingInspectiongeoJSON = convertToGeoJSONMetereadingInspection(res?.payload?.data?.MetereadingInspection);



      const MyTicketsgeoJSON = convertToGeoJSONMyTickets(res?.payload?.data?.MyTickets);

      setGeoDataMetereadingInspection(MetereadingInspectiongeoJSON);
      setFilteredMetereadingInspection(MetereadingInspectiongeoJSON);
      setGeoDataMeterReadingByUserId(MeterReadingByUserIdgeoJSON);
      setFilteredMeterReadingByUserId(MeterReadingByUserIdgeoJSON);
      setGeoDataMeterInstallation(MeterInstallationgeoJSON);
      setFilteredMeterInstallation(MeterInstallationgeoJSON);
      setGeoDataMyTickets(MyTicketsgeoJSON);
      setFilteredMyTickets(MyTicketsgeoJSON);


    } else {
      toast.error(res?.payload?.messages?.message ?? "Error fetching geolocation data")
    }

  }


  /*const fetchData = async (date) => {
    try {
      // Update the URL with the selected date
      const url = date ? `${baseUrl}&date=${date}` : baseUrl;
      const response = await fetch(url);
      const result = await response.json();

      if (result.success && result.data?.result) {
        const geoJSON = convertToGeoJSON(result.data.result);
        setGeoData(geoJSON);
        setFilteredData(geoJSON); // Initialize filtered data with full dataset

        // Extract unique names for filtering
        const names = Array.from(new Set(result.data.result.map((item) => item.ppFullname)));
        setUniqueNames(names);
      } else {
        console.error("API returned an error or no data.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };*/


  useEffect(() => {
    fetchData(selectedDate);
    // Fetch data on initial load or when the selected date changes
  }, [selectedDate]);

  useEffect(() => {
    if (filteredData && mapRef.current) {

      const bounds = L.geoJSON(filteredData).getBounds(); // Get bounds of filtered data
      try {
        mapRef.current.fitBounds(bounds); // Zoom to fit the bounds
      } catch (e) {

      }

    }
  }, [filteredData]); // This will run every time filteredData changes

  const handleFilterChange = (event) => {
    const type = event.target.value;
    setSelectedType(type);
    applyFilters(type, selectedName);
  };

  const handleNameFilterChange = (event) => {
    const name = event.target.value;
    setSelectedName(name);
    applyFilters(selectedType, name);
    getUserActivitiesData(selectedDate, -1, name);
  };

  const applyFilters = (type, name) => {
    if (!geoData) return;
    let filteredFeatures = geoData.features;

    // Filter by attdType
    if (type !== "ALL") {
      filteredFeatures = filteredFeatures.filter((feature) => feature.properties.attdType === type);
    }

    // Filter by ppFullname
    if (name !== "ALL") {
      filteredFeatures = filteredFeatures.filter((feature) => feature.properties.ppFullname === name);
    }

    const filteredGeoJSON = {
      type: "FeatureCollection",
      features: filteredFeatures,
    };

    setFilteredData(filteredGeoJSON);
  };

  const drawPolylines = () => {
    const polylineData = [];
    filteredData?.features.reduce((prev, current) => {
      if (prev && prev.properties.ppFullname === current.properties.ppFullname) {
        polylineData.push([
          [prev.geometry.coordinates[1], prev.geometry.coordinates[0]],
          [current.geometry.coordinates[1], current.geometry.coordinates[0]],
        ]);
      }
      return current;
    }, null);

    return polylineData.map((line, index) => (
      <Polyline key={index} positions={line} color="blue" />
    ));
  };

  const drawPathsWithArrows = (data) => {
    const paths = [];
    const markers = [];
    const arrowData = [];

    if (!data?.features) return { paths: null, markers: null, arrowData: null };

    function getMarkerIconUrl(type) {
      return `https://ndovuhr.com/${type}`; // Dynamic URL
    }

    data.features.reduce((prev, curr) => {
      const { ppFullname, clockedTime, attdClockedDate, attdType, ppFile } = curr.properties;
      const coordinates = [curr.geometry.coordinates[1], curr.geometry.coordinates[0]];

      // Add marker for current point with time information
      markers.push(
        <Marker
          key={`${ppFullname}-${clockedTime}`}
          position={coordinates}
          //icon={icons[attdType] || icons.DEFAULT}
          icon={L.icon({
            iconUrl: getMarkerIconUrl(ppFile),
            iconSize: [35, 50],
            iconAnchor: [16, 32],
            popupAnchor: [0, -32]
          })}
        >
          <Tooltip>
            <div>
              <strong>{ppFullname}</strong><br />
              {attdType}
              <br />
              {`Date: ${new Date(attdClockedDate).toLocaleDateString()}`}<br />
              {`Time: ${clockedTime}`}
            </div>
          </Tooltip>

        </Marker>
      );

      // Add polyline and arrow data if connecting to the previous point
      if (prev && prev.properties.ppFullname === curr.properties.ppFullname) {
        const line = [
          [prev.geometry.coordinates[1], prev.geometry.coordinates[0]],
          coordinates,
        ];
        paths.push(<Polyline key={`path-${paths.length}`} positions={line} color="blue" />);

        // Save data for arrow decorators
        arrowData.push(line);
      }

      return curr;
    }, null);


    return { paths, markers, arrowData };
  };



  const drawPathWithTime = (data) => {
    const paths = [];
    const markers = [];

    if (!data?.features) return { paths: null, markers: null };

    data.features.reduce((prev, curr) => {
      const { ppFullname, clockedTime, attdClockedDate, attdType } = curr.properties;
      const coordinates = [curr.geometry.coordinates[1], curr.geometry.coordinates[0]];

      const attClockedDate = new Date(attdClockedDate).toLocaleDateString();

      // Add marker for current point with time information
      markers.push(
        <Marker key={`${ppFullname}-${clockedTime}`} position={coordinates} icon={icons[curr.properties.attdType] || icons.DEFAULT}>
          <Tooltip>
            <div>
              <strong>{ppFullname}</strong><br />
              {attdType}<br />
              {`Time: ${clockedTime}`}<br />
              {`Date :${attClockedDate}`}
            </div>
          </Tooltip>
        </Marker>
      );

      // Add polyline connecting previous and current point
      if (prev && prev.properties.ppFullname === curr.properties.ppFullname) {
        paths.push([
          [prev.geometry.coordinates[1], prev.geometry.coordinates[0]],
          coordinates,
        ]);
      }
      return curr;
    }, null);

    return {
      paths: paths.map((line, index) => <Polyline key={`path-${index}`} positions={line} color="blue" />),
      markers,
    };
  };



  const onEachFeature = (feature, layer) => {
    if (feature.properties) {
      const { ppFullname, attdType, clockedTime, attdClockedDate } = feature.properties;
      const formattedDate = new Date(attdClockedDate).toLocaleDateString(); // Format date to exclude time
      layer.bindPopup(
        `<strong>${ppFullname}</strong><br/>Type: ${attdType}<br/>Time: ${clockedTime}<br/>Date: ${formattedDate}`
      );
    }
  };


  const onEachFeatureCustomerSurvey = (feature, layer) => {
    if (feature.properties) {
      const { customersurv_name, customersurv_status, customersurv_enq_reason_1, customersurv_created_date } = feature.properties;
      const formattedDate = new Date(customersurv_created_date).toLocaleDateString(); // Format date to exclude time
      layer.bindPopup(
        `<strong>Customer Survey</strong><br>Account Name: ${customersurv_name}<br/>Status: ${customersurv_status}<br>Reason:${customersurv_enq_reason_1}<br/>Date: ${formattedDate}`
      );
    }
  };

  const onEachFeatureMyTickets = (feature, layer) => {
    if (feature.properties) {
      const { tk_status, tk_message } = feature.properties;
      //const formattedDate = new Date(customersurv_created_date).toLocaleDateString(); // Format date to exclude time
      layer.bindPopup(
        `<strong>Tickets</strong><br>Status: ${tk_status}<br/>Message: ${tk_message}`
      );
    }
  };

  const onEachFeatureMeterInstallation = (feature, layer) => {
    if (feature.properties) {
      const { mui_ground_status, mui_request_type, mui_requested_date } = feature.properties;
      const formattedDate = new Date(mui_requested_date).toLocaleDateString(); // Format date to exclude time
      layer.bindPopup(
        `<strong>Meter Installation</strong><br/>Ground Status: ${mui_ground_status}<br>Request Type:${mui_request_type}<br/>Date: ${formattedDate}`
      );
    }
  };

  const onEachFeatureMeterReadingByUserId = (feature, layer) => {
    if (feature.properties) {
      const { c_account_name, mtr_status, mtr_reading_type, mtr_date } = feature.properties;
      const formattedDate = new Date(mtr_date).toLocaleDateString(); // Format date to exclude time
      layer.bindPopup(
        `<strong>Meter Reading</strong><br>Account Name: ${c_account_name}<br/>Status: ${mtr_status}<br>Reading Type:${mtr_reading_type}<br/>Date: ${formattedDate}`
      );
    }
  };

  const onEachFeatureMeterReadingInspection = (feature, layer) => {
    if (feature.properties) {
      const { c_acc_number, c_account_name, mtri_remarks, mtri_synced_date } = feature.properties;
      const formattedDate = new Date(mtri_synced_date).toLocaleDateString(); // Format date to exclude time
      layer.bindPopup(
        `<strong>Meter Reading Inspection</strong><br>Account Name: ${c_account_name}<br/>Account Number:  
         ${c_acc_number}<br>Remarks: ${mtri_remarks}<br/>Synced Date: ${formattedDate}`
      );
    }
  };

  const pointToLayer = (feature, latlng) => {
    //const icon = icons[feature.properties.attdType] || icons.DEFAULT;
    //return L.marker(latlng, { icon });
    return null;
  };

  const pointToLayerCustomerSurvey = (feature, latlng) => {
    const icon = icons[feature.properties.attdType] || icons.PUSH_PIN;
    return L.marker(latlng, { icon });
    //return null;
  };


  const pointToLayerMeterReadingInspection = (feature, latlng) => {
    const icon = icons[feature.properties.attdType] || icons.HOME;
    return L.marker(latlng, { icon });
    //return null;
  };

  const pointToLayerMetereadingByUser = (feature, latlng) => {
    const icon = icons[feature.properties.attdType] || icons.LOCATION;
    return L.marker(latlng, { icon });
    //return null;
  };

  const pointToLayerMeterIstallations = (feature, latlng) => {
    const icon = icons[feature.properties.attdType] || icons.DEFAULT;
    return L.marker(latlng, { icon });
    //return null;
  };

  const pointToLayerMyTickets = (feature, latlng) => {
    const icon = icons[feature.properties.attdType] || icons.TICKET;
    return L.marker(latlng, { icon });
    //return null;
  };





  const handleRowClick = (ppFullname, ppId) => {
    handlePersonChanged(ppFullname, ppId);
    // Filter features by ppFullname and update the map
    const filteredFeatures = geoData.features.filter((f) => f.properties.ppFullname === ppFullname);
    const filteredGeoJSON = {
      type: "FeatureCollection",
      features: filteredFeatures,
    };
    setFilteredData(filteredGeoJSON); // Update filtered data for map

    // Find the first feature to zoom into
    const feature = filteredFeatures[0];
    if (feature) {
      const latlng = L.latLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
      if (mapRef.current) {
        mapRef.current.flyTo(latlng, 16); // Zoom into the point
      }
    }

    setSelectedRow(ppFullname); // Mark the row as selected
  };
  //const { paths, markers } = drawPathWithTime(filteredData);
  const { paths, markers, arrowDecorators } = drawPathsWithArrows(filteredData);
  // Create the polyline decorator
  const decorator = L.polylineDecorator(paths, {
    patterns: [
      {
        offset: '10%', // Start position of the first arrow
        repeat: '20%', // Interval between arrows
        symbol: L.icon({
          pixelSize: 10,
          polygon: true,
          pathOptions: { color: 'red', fillOpacity: 1 },
        }),
      },
    ],
  });

  return (
    <div className="w-full overflow-y-scroll h-full">
      <div style={{ height: "90vh", display: "flex", flexDirection: "column" }}>
        {/* Filter Dropdowns */}
        <div style={{ padding: "10px", backgroundColor: "#f4f4f4", borderBottom: "1px solid #ccc" }}>
          <label htmlFor="typeFilter" style={{ marginRight: "10px" }}>
            Filter by Attendance Type:
          </label>
          <select id="typeFilter" value={selectedType} onChange={handleFilterChange} style={{ marginRight: "20px" }}>
            <option value="ALL">All</option>
            <option value="CHECK_IN">Check In</option>
            <option value="CHECK_OUT">Check Out</option>
            <option value="CHECK_OUT_LOG">Check Out Log</option>
            <option value="CHECK_IN_LOG">Check In Log</option>
          </select>

          <label htmlFor="nameFilter" style={{ marginRight: "10px" }}>
            Filter by Name:
          </label>
          <select id="nameFilter" value={selectedName} onChange={handleNameFilterChange}>
            <option value="ALL">All</option>
            {uniqueNames.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
          <label htmlFor="dateFilter" style={{ marginRight: "10px" }}>
            Select Date:
          </label>
          <input
            type="date"
            id="dateFilter"
            value={selectedDate}
            onChange={handleDateChange}
          />
        </div>

        {/* Map */}
        <MapContainer center={[-1.346389, 36.6679022]} zoom={14} style={{ flex: 1 }} ref={mapRef}>
          <LayersControl position="topright">
            <BaseLayer checked name="OpenStreetMap">
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </BaseLayer>
            <BaseLayer name="Google Maps">
              <TileLayer
                attribution='&copy; <a href="https://www.google.com/maps">Google Maps</a>'
                url="https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                subdomains={["mt0", "mt1", "mt2", "mt3"]}
              />
            </BaseLayer>
            <BaseLayer name="Google Hybrid">
              <TileLayer
                attribution='&copy; <a href="https://www.google.com/maps">Google Maps</a>'
                url="https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
                subdomains={["mt0", "mt1", "mt2", "mt3"]}
              />
            </BaseLayer>
          </LayersControl>
          {/* GeoJSON Layer for filtered data */}
          {filteredData && (
            <GeoJSON
              key={JSON.stringify(filteredData)} // Force rerender by updating the key
              data={filteredData}
              onEachFeature={onEachFeature}
              pointToLayer={pointToLayer}
            />
          )}
          {filteredCustomerSurvey && <GeoJSON
            key={JSON.stringify(filteredCustomerSurvey)} // Force rerender by updating the key
            data={filteredCustomerSurvey}
            onEachFeature={onEachFeatureCustomerSurvey}
            pointToLayer={pointToLayerCustomerSurvey}
          />}

          {FilteredMyTickets && <GeoJSON
            key={JSON.stringify(FilteredMyTickets)} // Force rerender by updating the key
            data={FilteredMyTickets}
            onEachFeature={onEachFeatureMyTickets}
            pointToLayer={pointToLayerMyTickets}
          />}

          {FilteredMeterInstallation && <GeoJSON
            key={JSON.stringify(FilteredMeterInstallation)} // Force rerender by updating the key
            data={FilteredMeterInstallation}
            onEachFeature={onEachFeatureMeterInstallation}
            pointToLayer={pointToLayerMeterIstallations}
          />}

          {FilteredMeterReadingByUserId && <GeoJSON
            key={JSON.stringify(FilteredMeterReadingByUserId)} // Force rerender by updating the key
            data={FilteredMeterReadingByUserId}
            onEachFeature={onEachFeatureMeterReadingByUserId}
            pointToLayer={pointToLayerMetereadingByUser}
          />}

          {FilteredMetereadingInspection && <GeoJSON
            key={JSON.stringify(FilteredMetereadingInspection)} // Force rerender by updating the key
            data={FilteredMetereadingInspection}
            onEachFeature={onEachFeatureMeterReadingInspection}
            pointToLayer={pointToLayerMeterReadingInspection}
          />}
          {markers}
          {paths}
          {arrowDecorators}



        </MapContainer>


        <div style={{ flex: 1, padding: "10px", maxHeight: "20vh", overflowY: "auto", backgroundColor: "#fff", borderLeft: "1px solid #ccc" }}>
          {/* Table */}
          <table
            key={JSON.stringify(filteredData)} // Forces re-render when filteredData changes
            style={{
              width: "100%",
              height: "20vh",
              borderCollapse: "collapse",
              border: "1px solid #ccc",
            }}>
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Check-In/Out Time</th>
                <th>Coordinates</th>
              </tr>
            </thead>
            <tbody >
              {filteredData?.features
                .sort((a, b) => {
                  // Sort by ppFullname first
                  if (a.properties.ppFullname > b.properties.ppFullname) return 1;
                  if (a.properties.ppFullname < b.properties.ppFullname) return -1;

                  // If ppFullname is the same, sort by time (clockedTime or attdClockedDate)
                  const aTime = a.properties.clockedTime || a.properties.attdClockedDate;
                  const bTime = b.properties.clockedTime || b.properties.attdClockedDate;

                  // Compare times
                  return new Date(bTime) - new Date(aTime);
                })
                .map((feature) => {
                  const { ppId, ppFullname, clockedTime, attdClockedDate } = feature.properties;
                  const coordinates = feature.geometry.coordinates.join(", ");
                  return (
                    <tr
                      key={feature.properties.ppFile}
                      onClick={() => handleRowClick(ppFullname, ppId)}
                      style={{
                        cursor: "pointer",
                        //backgroundColor: selectedRow === ppFullname ? "#e0e0e0" : "white",
                      }}
                    >
                      <td>{ppFullname}</td>
                      <td>{clockedTime}</td>
                      <td>{coordinates}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
